import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../../../toolkit/uicomponentcss';
import { Colors } from '../../../../../../utils/resources/colors';

export interface CategoriesCardCSSStyle extends UIComponentCSSStyle
{
    getImgCSSStyle(): object;
    getTitleCSSStyle(): object;
    getTintDivCSSStyle(isHovered: boolean): object;
}

export class CategoriesCardCSSStyleImpl extends UIComponentCSSStyleImpl implements CategoriesCardCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            height: '160px', 
            width: '150px', 
            marginLeft: "20px",
            marginRight: "20px",
            marginTop: "20px",
            objectFit: 'cover', 
            position: 'relative',
            cursor: "pointer",
        };
    }

    getImgCSSStyle(): object 
    {
        return {
            objectFit: 'cover', 
            width: '100%', 
            height: '100%',
            borderRadius: "28.5px",
            cursor: "pointer",
        };
    }

    getTintDivCSSStyle(isHovered: boolean): object{
        return {
            position: "absolute",
            width: '100%', 
            height: '100%',
            display: "flex",
            opacity: isHovered ? 0.7 : 0.5,
            borderRadius: "28.5px",
            cursor: "pointer",
            backgroundColor: isHovered ? "#FFCB08": "#000000",
        };
    }

    getTitleCSSStyle(): object {
        return {
            borderRadius: "8px",
            display: "flex",
            textAlign: "center",
            width: '100%', 
            height: 'auto',
            cursor: "pointer",
            letterSpacing: 0,
            position: "absolute",
            fontSize: "20.56",
            color:this.getResources().getColor(Colors.color_5),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "28px",
            alignItems: 'center', 
            justifyContent: 'center', 
            top: '70px',

        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/categories/viewmodel/categoriescard/categoriescardcssstyle.tsx